import { Checkbox, Popconfirm } from "antd";
import React from "react";
import moment from "moment";

export const handleMinutesToDate = (minutesData) => {
  if (!minutesData) {
    return "";
  }
  let hour = 0;
  let minutes = 0;
  hour = Math.floor(Number(minutesData) / 60);
  minutes = minutesData - hour * 60;
  return `${hour >= 10 ? hour : `0${hour}`}:${
    minutes >= 10 ? minutes : `0${minutes}`
  }`;
};

export const columns = (context, isPaymentCustomer = false) => [
  {
    title: "STT",
    dataIndex: "index",
    key: "index",
    className: "column-60",
  },
  {
    title: "Thứ",
    className: "column-80",
    dataIndex: "week_day", // should edit
    key: "week_day",
  },
  {
    title: "Ngày",
    dataIndex: "date",
    key: "date",
    className: "column-80",
    render: (date) => (
      <div>{date ? moment(date).format("DD/MM/YYYY") : ""}</div>
    ),
  },
  {
    title: "Người sử dụng",
    className: "column-200",
    dataIndex: "customer_name_used",
    key: "customer_name_used",
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Bộ phận",
    dataIndex: "customer_department",
    key: "customer_department",
    className: "column-80",
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Hành trình chuyến đi",
    className: "column-300",
    dataIndex: "trip_itinerary",
    key: "trip_itinerary",
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Số km KH sử dụng (Có lái)",
    dataIndex: "used_km",
    editable: false,
    key: "used_km",
    isPercent: true,
    inputType: "input-number",
  },
  {
    title: "Số km KH sử dụng (Tự lái)",
    dataIndex: "used_km_self_drive",
    editable: false,
    key: "used_km_self_drive",
    isPercent: true,
    inputType: "input-number",
  },
  {
    title: "Thời gian làm việc (GPS)",
    className: "column-200",
    editable: true,
    dataIndex: "gps_work_time", // [working_time_gps_from, working_time_gps_to] // should edit
    key: "gps_work_time",
    inputType: "range-time",
    render: (gps_work_time) => (
      <div>
        {gps_work_time &&
          gps_work_time.map((value, index) => {
            let stringValue = "";
            if (value) {
              stringValue = moment(value, "HH:mm:ss").format("HH:mm");
            } else {
              stringValue = "-- : --";
            }
            if (index === 0) {
              stringValue = stringValue + " - ";
            }
            return stringValue;
          })}
      </div>
    ),
  },
  {
    title: "Over time",
    dataIndex: "over_time",
    editable: false,
    key: "over_time",
    inputType: "input-number",
    isPercent: true,
    render: (data) => <span>{handleMinutesToDate(data)}</span>,
  },
  {
    title: "Over km có lái (Km)",
    dataIndex: "over_km",
    editable: false,
    key: "over_km",
    inputType: "input-number",
  },
  {
    title: "Over km tự lái (Km)",
    dataIndex: "over_km_self_drive",
    editable: false,
    key: "over_km_self_drive",
    inputType: "input-number",
  },
  {
    title: "Overnight (đêm)",
    dataIndex: "overnight",
    editable: false,
    key: "overnight",
    inputType: "input-number",
  },
  {
    title: "Ngày lễ",
    dataIndex: "is_holiday",
    editable: false,
    key: "is_holiday",
    render: (is_holiday) => <Checkbox disabled checked={is_holiday}></Checkbox>,
  },
  {
    title: "Cuối tuần",
    dataIndex: "is_weekend",
    key: "is_weekend",
    editable: true,
    inputType: "checkbox",
    render: (is_weekend) => <Checkbox disabled checked={is_weekend}></Checkbox>,
  },
  {
    title: "Có lái",
    dataIndex: "is_with_driver",
    key: "is_with_driver",
    editable: true,
    inputType: "checkbox",
    render: (is_self_drive) => (
      <Checkbox disabled checked={is_self_drive}></Checkbox>
    ),
  },
  {
    title: "Tự lái",
    dataIndex: "is_self_drive",
    key: "is_self_drive",
    editable: true,
    inputType: "checkbox",
    render: (is_self_drive) => (
      <Checkbox disabled checked={is_self_drive}></Checkbox>
    ),
  },
  {
    title: "Tài xế",
    dataIndex: "driver_name",
    editable: true,
    key: "driver_name",
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Biển KS",
    dataIndex: "vehicle_number_plate",
    editable: true,
    key: "vehicle_number_plate",
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Chi phí đỗ xe (VNĐ)",
    className: "column-150",
    dataIndex: isPaymentCustomer ? "parking_fee" : "CT008",
    editable: true,
    key: isPaymentCustomer ? "parking_fee" : "CT008",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Chi phí cầu đường (VNĐ)",
    className: "column-150",
    dataIndex: isPaymentCustomer ? "tolls_fee" : "CT007",
    editable: true,
    key: isPaymentCustomer ? "tolls_fee" : "CT007",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Chi phí lưu đêm (VNĐ)",
    className: "column-150",
    dataIndex: "CT011",
    editable: true,
    key: "CT011",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Trạng thái ký",
    className: "column-200",
    dataIndex: "signature_status",
    editable: false,
    key: "signature_status",
    render: (signature_status) => (
      <span>
        {signature_status === true
          ? "Đã ký"
          : signature_status === false
          ? "Chưa ký"
          : ""}
      </span>
    ),
  },
  {
    title: "Ảnh chữ ký",
    className: "column-200",
    dataIndex: "signature_image_url",
    editable: false,
    key: "signature_image_url",
    render: (links) => {
      if (!links) {
        return "";
      }
      return (
        <span>
          {links.map((link, index) => {
            return (
              link && (
                <span className="link-container">
                  <a target="_blank" className="one-line-link" href={link}>
                    Link{index}
                  </a>
                  {index !== links.length - 1 ? ", " : ""}
                </span>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Nhận xét",
    className: "column-200",
    dataIndex: "signature_comment",
    editable: false,
    key: "signature_comment",
    render: (list) => {
      return list
        ? list.map((item, index) => {
            return item && <div key={index}>{item}</div>;
          })
        : "";
    },
  },
  {
    title: "Ghi chú",
    className: "column-200 noteMW",
    dataIndex: "note",
    key: "note",
  },
];

export const columnsDriverless = (context) => [
  {
    title: "STT",
    dataIndex: "index",
    key: "index",
    className: "column-60",
  },
  {
    title: "Ngày",
    dataIndex: "date",
    key: "date",
    className: "column-80",
    render: (date) => <div>{date}</div>,
  },
  {
    title: "Số km bắt đầu",
    dataIndex: "km_start",
    editable: true,
    key: "km_start",
    //className: 'column-80',
    isPercent: false,
    inputType: "input-number",
  },
  {
    title: "Số km kết thúc",
    dataIndex: "km_end",
    editable: true,
    key: "km_end",
    isPercent: false,
    inputType: "input-number",
  },
  {
    title: "Số km đã đi",
    dataIndex: "used_km",
    editable: false,
    key: "used_km",
    isPercent: false,
    inputType: "input-number",
  },
  {
    title: "Over km (Km)",
    dataIndex: "over_km",
    editable: false,
    key: "over_km",
    inputType: "input-number",
  },
  {
    title: "Tài xế",
    dataIndex: "driver_name",
    editable: false,
    key: "driver_name",
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Biển KS",
    dataIndex: "vehicle_number_plate",
    editable: false,
    key: "vehicle_number_plate",
    inputType: "input-text",
    render: (item) => <span className="link-container">{item}</span>,
  },
  {
    title: "Ghi chú",
    className: "column-200 noteMW",
    dataIndex: "note",
    key: "note",
  },
];

const styles = {
  mr8: {
    marginRight: 8,
  },
};

export const handleMoneyValue = (money) => {
  if (!money) {
    return "";
  }
  return money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
